import {Color} from '~/constants/style';

export const chartContainerStyle = {
  width: 120,
  height: 120,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  bgcolor: Color.White,
  borderRadius: '50%',
};

export const titleStyle = {
  fontWeight: 600,
  color: Color.Purple600,
  whiteSpace: 'nowrap',
  fontSize: '18px',
};

export const fieldStyle = {
  fontSize: '14px',
  fontWeight: 600,
  color: Color.TextPrimary,
  lineHeight: 1.2,
  margin: 0,
  padding: 0,
  display: 'block',
};

export const percentageStyle = {
  fontSize: '13px',
  fontWeight: 400,
  color: Color.TextSecondary,
  lineHeight: 1.2,
  margin: 0,
  padding: 0,
  display: 'block',
};

export const legendDotStyle = {
  width: 18,
  height: 18,
  borderRadius: '4px',
  flexShrink: 0,
  position: 'relative' as const,
  top: '0.1em',
};

export const legendItemContainerStyle = {
  display: 'flex',
  alignItems: 'flex-start',
  gap: 1.5,
};

export const legendItemContentStyle = {
  display: 'flex',
  flexDirection: 'column' as const,
  lineHeight: 1,
};

export const stackDirectionRowStyle = {
  direction: 'row' as const,
  alignItems: 'center',
  spacing: 1,
};

export const tooltipContainerStyle = {
  p: 1.2,
  minWidth: 130,
  maxWidth: 200,
  bgcolor: Color.White,
  borderRadius: 2,
  boxShadow: 3,
  display: 'flex',
  flexDirection: 'column' as const,
  alignItems: 'stretch',
  border: `1px solid ${Color.Grey300}`,
};

export const tooltipTopRowStyle = {
  display: 'flex',
  flexDirection: 'row' as const,
  alignItems: 'center',
  justifyContent: 'space-between',
  mb: 0.2,
};

export const tooltipCountStyle = {
  fontWeight: 700,
  color: Color.Grey500,
  fontSize: 18,
};

export const tooltipColorBoxStyle = {
  width: 16,
  height: 16,
  borderRadius: 1,
  bgcolor: undefined,
  ml: 1,
};

export const tooltipTextStyle = {
  color: Color.TextPrimary,
  fontWeight: 400,
  textTransform: 'none' as const,
  mt: 0.2,
  fontSize: 13,
  textAlign: 'left' as const,
  width: '100%',
  lineHeight: 1.2,
  wordBreak: 'break-word' as const,
};

export const rechartsTooltipWrapperStyle = {
  outline: 'none',
  zIndex: 1000,
};
